import { render, staticRenderFns } from "./OptionsDialog.vue?vue&type=template&id=5436f03a&scoped=true&"
import script from "./OptionsDialog.vue?vue&type=script&lang=js&"
export * from "./OptionsDialog.vue?vue&type=script&lang=js&"
import style0 from "./OptionsDialog.vue?vue&type=style&index=0&id=5436f03a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5436f03a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Input: require('/data/jenkins-data/workspace/Unicew-mobile-pro/pagePC/components/Design/Input.vue').default})
